import { QueryKey, useQuery } from "@tanstack/react-query";
import { WithRequiredProperties } from "@common/types/base/generics";
import { getTransactionsStatistics } from "@api/transaction.api";
import { useActiveWorkspace } from "@hooks/useActiveWorkspace";
import { TransactionsFilters } from "./filters/lib";
import {
    convertFiltersToDto,
    TRANSACTIONS_CACHE_DURATION,
} from "./useTransactionsQuery";

export const TRANSACTIONS_STATISTICS_QUERY_KEY = "transactions-stats";

interface UseTransactionsQueryParam {
    filters: WithRequiredProperties<TransactionsFilters, "entityIds">;
    workspaceId: string;
}

const queryKey = ({
    filters,
    workspaceId,
}: UseTransactionsQueryParam): QueryKey => [
    TRANSACTIONS_STATISTICS_QUERY_KEY,
    workspaceId,
    filters,
];

export function useTransactionsStatisticsQuery({
    filters,
    enabled: externalEnabled = true,
}: Omit<UseTransactionsQueryParam, "workspaceId"> & { enabled?: boolean }) {
    const workspace = useActiveWorkspace();
    const workspaceId = workspace?.id ?? "";

    return useQuery({
        queryKey: queryKey({ filters, workspaceId }),
        queryFn: () =>
            getTransactionsStatistics(
                convertFiltersToDto(filters),
                workspaceId,
            ),
        staleTime: TRANSACTIONS_CACHE_DURATION,
        enabled:
            externalEnabled && !!convertFiltersToDto(filters).entityIds?.length,
    });
}
